import { render } from "./allList.vue?vue&type=template&id=2aa500ca"
import script from "./allList.vue?vue&type=script&lang=js"
export * from "./allList.vue?vue&type=script&lang=js"

import "./allList.vue?vue&type=style&index=0&id=2aa500ca&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__